import { unrefElement as s } from "./index562.js";
import { isClient as f } from "./index599.js";
const u = (e, t = []) => {
  const { placement: n, strategy: o, popperOptions: i } = e, r = {
    placement: n,
    strategy: o,
    ...i,
    modifiers: [...p(e), ...t]
  };
  return l(r, i?.modifiers), r;
}, c = (e) => {
  if (f)
    return s(e);
};
function p(e) {
  const { offset: t, gpuAcceleration: n, fallbackPlacements: o } = e;
  return [
    {
      name: "offset",
      options: {
        offset: [0, t ?? 12]
      }
    },
    {
      name: "preventOverflow",
      options: {
        padding: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    },
    {
      name: "flip",
      options: {
        padding: 5,
        fallbackPlacements: o
      }
    },
    {
      name: "computeStyles",
      options: {
        gpuAcceleration: n
      }
    }
  ];
}
function l(e, t) {
  t && (e.modifiers = [...e.modifiers, ...t ?? []]);
}
export {
  u as buildPopperOptions,
  c as unwrapMeasurableEl
};
